export default {
  en: {
    setting: 'Setting',
    general: 'General',
    editGeneral: 'Edit General',
    logo: 'Logo',
    currency: 'Currency',
    contract: 'Contract',
    refCodeFormat: 'Ref Code Format',
    saveChange: 'Save Change',
    cancel: 'Cancel',
    reset: 'Reset',
    remarkImageSize: '* Image size < 5MB',
    imageSizeOverMessage: 'Image size must be smaller than 5MB',
    saveSettingSuccessTitle: 'Success',
    saveSettingSuccessMessage: 'Update General Setting Success',
    specialOffer: 'Special Offer'
  },
  th: {
    setting: 'การตั้งค่า',
    general: 'ข้อมูลพื้นฐาน',
    editGeneral: 'แก้ไขข้อมูลพื้นฐาน',
    logo: 'โลโก้',
    currency: 'สกุลเงิน',
    contract: 'สัญญา',
    refCodeFormat: 'รูปแบบรหัสอ้างอิง',
    saveChange: 'บันทึก',
    cancel: 'ยกเลิก',
    reset: 'ยกเลิกการเปลี่ยนแปลง',
    remarkImageSize: 'ขนาดรูปภาพ < 5MB',
    imageSizeOverMessage: 'ขนาดรูปภาพต้องไม่เกิน 5MB',
    saveSettingSuccessTitle: 'บันทึกสำเร็จ',
    saveSettingSuccessMessage: 'บันทึกการตั้งค่าสำเร็จ',
    specialOffer: 'ข้อเสนอพิเศษ'
  }
}
